// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"9a6bb46a","36":"58b4c774","222":"1ef2021c","231":"57948b94","318":"74180919","371":"4a37fd5a","423":"869dc3c2","453":"0b282149","465":"858e5975","569":"38d6c342"}[chunkId] + ".chunk.js";
};